import { type AiResponse, type CatalogProductCard } from '../../types/ai';
import { maybeFixMojibake } from '../../utils/mojibake';

import { stripSuggestedActionsMarkers } from './chat-protocol';

type AiResponseInput = {
  metadata: Partial<AiResponse>;
  streamedMessage: string;
  productCards: CatalogProductCard[] | undefined;
  requestChannel: string | undefined;
};

// Metadatan kommer sist och bär den färdiga texten. Saknas den har vi ändå
// samlat chunkarna under vägen — men en tom metadata-text betyder "inget nytt",
// inte "radera svaret".
export const toAiResponse = ({
  metadata,
  streamedMessage,
  productCards,
  requestChannel,
}: AiResponseInput): AiResponse => {
  const finalizedMessage = maybeFixMojibake(
    typeof metadata.message === 'string' && metadata.message.trim().length > 0
      ? metadata.message
      : streamedMessage,
  );

  return {
    message: stripSuggestedActionsMarkers(finalizedMessage),
    code: typeof metadata.code === 'string' ? metadata.code : undefined,
    assistantMessageId:
      typeof metadata.assistantMessageId === 'string' ? metadata.assistantMessageId : undefined,
    sources: metadata.sources || [],
    channel: metadata.channel || requestChannel || 'playground',
    orderContext: metadata.orderContext,
    responseMode: metadata.responseMode,
    suppressOrderContext: metadata.suppressOrderContext,
    isVerified: metadata.isVerified,
    usedOrderNumber: metadata.usedOrderNumber,
    usedPostalCode: metadata.usedPostalCode,
    shouldEndChat: metadata.shouldEndChat,
    shouldContactSupport: metadata.shouldContactSupport,
    detectedLanguage: metadata.detectedLanguage,
    customerSwitched: metadata.customerSwitched,
    verificationUpgradedInPlace: metadata.verificationUpgradedInPlace,
    hasVerifiedCustomer: metadata.hasVerifiedCustomer,
    outfitProducts: metadata.outfitProducts,
    productCards,
    selectedProducts: metadata.selectedProducts,
    routing:
      metadata.routing && typeof metadata.routing === 'object'
        ? (metadata.routing as AiResponse['routing'])
        : undefined,
    sessionId: metadata.sessionId,
    session: metadata.session,
  };
};
